import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Select, Typography } from 'antd';
import { TrainingProjectsStore } from '../../stores';
import { trainingProjectFormFields, trainingProjectModuleTypeValues } from '../../misc/constants';

interface Props {
    store: TrainingProjectsStore;
}

const TrainingProjectModuleTypeSelect: React.FC<Props> = ({ store }) => {
    return (
        <>
            <Typography.Title level={5}>Module Type</Typography.Title>

            <Form.Item
                name={trainingProjectFormFields.moduleType}
                initialValue={
                    store.editableTrainingProject
                        ? store.editableTrainingProject.moduleType
                        : trainingProjectModuleTypeValues.Predict
                }
            >
                <Select
                    placeholder="Select module type"
                    options={Object.values(trainingProjectModuleTypeValues).map(value => ({
                        value,
                        label: value
                    }))}
                    allowClear
                />
            </Form.Item>
        </>
    );
};

export default observer(TrainingProjectModuleTypeSelect);
